import { onMounted, onUnmounted } from 'vue'

const BUTTON_PRESS_EVENT = 'djr:button_press'

/**
 * Composable to handle the global button press event.
 * Automatically sets up and cleans up the event listener.
 */
export function useButtonEvent(handler) {
    onMounted(() => {
        window.addEventListener(BUTTON_PRESS_EVENT, handler)
    })

    onUnmounted(() => {
        window.removeEventListener(BUTTON_PRESS_EVENT, handler)
    })
}

export { BUTTON_PRESS_EVENT }
